import { render, staticRenderFns } from "./VasCatalog.vue?vue&type=template&id=39120757&"
import script from "./VasCatalog.vue?vue&type=script&lang=ts&"
export * from "./VasCatalog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports